<div class="text">
  @if (!isListItem) {
    <div  [ngClass]="{'boxed':boxed}">
      <span [ngStyle]="{color:color}">{{beforeFirstIcon}}</span>
      @if (iconCount > 0) {
        <span [ngStyle]="" class="icon inline-icon {{getFirstIcon()}}">&nbsp;</span>
      }
      @if (iconCount > 0) {
        <span [ngStyle]="{'color':color}">{{beforeSecondIcon}}</span>
      }
      @if (iconCount > 1) {
        <span [ngStyle]="" class="icon inline-icon {{getSecondIcon()}}">&nbsp;</span>
      }
      @if (iconCount > 1) {
        <span [ngStyle]="{'color':color}">{{afterSecondIcon}}</span>
      }
    </div>
  }
  @if (isListItem) {
    <div  [ngClass]="{'boxed':boxed,'dashed':dashed}" [ngStyle]="{'border-color':color}">
      <!--<span *ngIf="dashed && !underlined" class="dashed" [ngStyle]="{'border-color':color}">&nbsp;</span>-->
      <span [ngStyle]="{color:color}" [ngClass]="{'dashedValue':dashed}" class="listItemKey"><span [ngStyle]="{color:color}">{{getListItemKey()}}</span></span>
      @if (valueHidden) {
        <span [ngStyle]="{color:color}" [ngClass]="{'dashedValue':dashed}" class="listItemValue"><span [ngStyle]="{color:color}">---</span></span>
      }
      @if (!valueHidden) {
        <span [ngStyle]="{color:color}" [ngClass]="{'dashedValue':dashed}" class="listItemValue"><span [ngStyle]="{color:color}">{{getListItemValue()}}</span></span>
      }
      @if (underlined && lines() <=1) {
        <span class="hr" [ngStyle]="{'border-color':color}">&nbsp;</span>
      }
      @if (underlined && lines() > 1) {
        <span class="hr-nospace" [ngStyle]="{'border-color':color}">&nbsp;</span>
      }
    </div>
  }
</div>
